import { init } from '../media-init';

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('section.media-component').forEach(init);
});
